module.exports = __webpack_public_path__ + "static/media/Balenciaga-Gray-Arena-Leather-Shopper-Lyst_thumb.ceb40c41.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/bags/Balenciaga-Gray-Arena-Leather-Shopper-Lyst_thumb.png
// module id = 210
// module chunks = 0